<template>
  <div class="index">
    <div class="index-con">
      <div class="title-big" style="color: #8a6d3b">
        {{ $t("loginThenbigtitle") }}
      </div>
      <div class="login-nav">
        <!-- <div @click="toOther('/submitPaper')" class="login-nav-list">
					<i class="el-icon-document"></i>
					<p>Submit paper</p>
				</div> -->
        <!--  @click="toOther('/registration')" -->
        <!--  @click="toOther('/uploadPaper')" -->
        <div class="login-nav-list bg-gray">
          <i class="el-icon-edit-outline"></i>
          <p>注册</p>
        </div>
        <div class="login-nav-list" @click="toOther('/submissionUploadzh')">
          <i class="el-icon-copy-document"></i>
          <p>在线提交系统</p>
          <span>(摘要)</span>
        </div>
        <!--  @click="toOther('/payment')" -->
        <div class="login-nav-list" @click="hereFn">
          <i class="el-icon-bank-card"></i>
          <p>支付</p>
        </div> 
      </div>

      <div class="nav-lists border-green">
        <div class="nav-title bg-green">
          如果您是演讲者，您需要请点击“上传摘要”
        </div>
        <div class="nav-lists-con">
          <span class="pay-btn pay-add mb-20 p-0-20" @click="toOther('/submissionUploadzh')">
            上传摘要
          </span>
          <el-table :data="list" border style="width: 100%">
            <el-table-column prop="report_id" label="文章 ID" width="110">
            </el-table-column>
            <el-table-column prop="title" label="题目"> </el-table-column>
            <el-table-column prop="submissionType" label="提交类型">
              <template slot-scope="scope">
                <p>
                  {{
                    scope.row.submissionType == 1
                    ? "摘要（口头陈述或海报)"
                    : scope.row.submissionType == 2
                      ? "摘要（仅海报）"
                      : "全文（手稿）"
                  }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="keywords" label="关键词"> </el-table-column>
            <el-table-column prop="keywords" label="">
              <template slot-scope="scope">
                <span class="pay-btn bg-blue" @click="
                toOther('/submissionUploadzh?id=' + scope.row.report_id)
                  ">
                  编辑
                </span>
                <span class="pay-btn bg-red" @click="deleteFn(scope.row, scope.$index)">
                  删除
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      visitor_id: "",
    };
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.visitor_id = localStorage.getItem("visitor_id");
    if (!token) {
      this.$router.push("/loginzh");
      return;
    }
    this.getList();
  },
  methods: {
    hereFn() {
      this.$router.push("/here");
    },
    toRegFn() {
      this.$router.push("/submissRegistrationzh");
    },
    toPayFn() {
      this.$router.push("/visa");
    },
    deleteFn(item, index) {
      console.log(item, index);
      var that = this;
      this.$confirm("是否要删除? ", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          that.$http
            .delete_report({
              report_id: item.report_id,
            })
            .then((res) => {
              if (res.code == 200) {
                that.list.splice(index, 1);
                that.$message.success("删除成功");
              } else {
                that.$message.error(res.msg);
              }
            });
        })
        .then(() => { });
    },
    getList() {
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .report_list({
          visitor_id: this.visitor_id,
        })
        .then((res) => {
          loading.close();
          if (res.code == 200) {
            that.list = res.data;
          } else {
            that.$message.error(res.msg);
          }
        });
    },
    toOther(con) {
      console.log(con)
      this.$router.push(con);
    },
    toReg() {
      this.$router.push("/reg");
    },
  },
};
</script>

<style scoped>
.title-big {
  color: #8a6d3b;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 50px;
  padding-bottom: 20px;
  margin-top: 50px;
  font-size: 30px;
  border-bottom: 5px solid #8a6d3b;
}

.text-blue {
  color: #28d6ec;
}

.text-brown {
  color: chocolate;
}

.pay-btn {
  color: #fff;
  border-radius: 4px;
  background-color: #5bc0de;
  padding: 0 25px;
  cursor: pointer;
  /* width: 100px; */
  height: 30px;
  line-height: 30px;
  text-align: center;
  box-sizing: border-box;
  display: inline-block;
  margin: 0 4px;
}

.pay-add {
  padding: 4px 40px;
  background: #3c763d;
  height: auto;
  font-size: 18px;
}

.mb-20 {
  margin-bottom: 20px;
}

.bg-red {
  background: #b13a3a;
}

.bg-green {
  background: rgb(29 188 206);
}

.bg-blue {
  background: rgb(29 188 206);
}

.nav-lists {
  margin-bottom: 20px;
  border: 1px solid #bce8f1;
  border-radius: 4px;
}

.coll-lists {
  border: 1px solid #ddd;
  border-bottom: 0;
  border-radius: 4px;
}

.coll-list {
  display: flex;
  border-bottom: 1px solid #ddd;
  align-items: center;
}

.coll-list:nth-of-type(2n),
.coll-list:hover {
  background: #f9f9f9;
}

.coll-list p {
  flex: 1;
  box-sizing: border-box;
  border-right: 1px solid #ddd;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 15px 0 15px 15px;
  box-sizing: border-box;
}

.coll-list p:nth-last-of-type(1) {
  border-right: 0;
}

.sub-lists .w-100 {
  width: 180px;
  box-sizing: border-box;
  padding: 15px 0 15px 0;
  flex-shrink: 0;
  flex: none;
}

.sub-lists .coll-list p:nth-of-type(1) {
  flex: 1.5;
}

.pay-lists .coll-list p:nth-of-type(1),
.reg-lists .coll-list p:nth-of-type(2),
.sub-lists .coll-list p:nth-of-type(2),
.sub-lists .coll-list p:nth-of-type(3) {
  flex: 2;
}

.nav-title {
  color: #31708f;
  background-color: #d9edf7;
  border-bottom: 1px solid transparent;
  border-color: #bce8f1;
  padding: 10px 15px;
  border-top-left-radius: 3px;
  display: flex;
  align-items: center;
  border-top-right-radius: 3px;
}

.bg-green {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.border-green {
  border-color: #d6e9c6;
}

.nav-title i {
  margin-right: 5px;
}

.nav-lists-con {
  padding: 20px;
  box-sizing: border-box;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
}

.login-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-nav-list {
  flex: 1;
  margin-right: 35px;
  color: #31708f;
  background-color: #d9edf7;
  border: 1px solid #bce8f1;
  padding: 15px;
  margin-bottom: 20px;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}

.login-nav-list.bg-gray {
  flex: 0.6;
}

.login-nav-list p {
  font-size: 24px;
  font-weight: 500;
}

.login-nav-list:nth-of-type(2) {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.login-nav-list:nth-of-type(1) {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.login-nav-list:nth-of-type(4) {
  margin-right: 0;
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}

.login-nav-list i {
  font-size: 40px;
}

.login-nav-list img {
  height: 35px;
  width: auto;
}

.bg-gray {
  background: #999 !important;
  border-color: #999 !important;
  color: #444 !important;
  cursor: no-drop;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .login-nav {
    display: block;
  }

  .nav-lists,
  .login-nav-list {
    width: calc(100% - 40px);
    margin: 20px;
  }

  .sub-lists .coll-list p {
    width: 33.3%;
    padding: 15px 0 15px 5px;
  }

  .reg-lists .coll-list p {
    width: 25%;
  }

  .sub-lists .coll-list p:nth-of-type(1),
  .pay-lists .coll-list p:nth-of-type(1),
  .reg-lists .coll-list p:nth-of-type(2),
  .sub-lists .coll-list p:nth-of-type(2),
  .sub-lists .coll-list p:nth-of-type(3) {
    flex: 1;
  }

  .sub-lists .coll-list p:nth-last-of-type(1),
  .sub-lists .coll-list p:nth-last-of-type(2),
  .reg-lists .coll-list p:nth-last-of-type(2),
  .pay-lists .coll-list p:nth-last-of-type(1) {
    display: none;
  }

  .pay-btn {
    padding: 0 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LoginThenzh.vue